<template>
    <div v-if="orgid == 3" class="printdiv">
        <div class="page-border"></div>
        <!-- <div style="display: flex;">
            <div style="width: 30%; float: left;">
                <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
            </div>

            <div style="width: 70%; float: right;">
                <h3 style="text-transform: uppercase;">
                    {{ person_details.rep_header.trust_name }}
                </h3>
                <h1 style="text-transform: uppercase; text-decoration: underline;">
                    {{ person_details.rep_header.school_name }}
                </h1>
                <h4 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                    {{ person_details.rep_header.address }}
                </h4>
                <div style="font-weight: bold;">
                    <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                    <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email }}</span><br />
                    <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                </div>
            </div>
        </div> -->

        <div>
            <img src="https://eduplusschool.s3.ap-south-1.amazonaws.com/zeal/CBSE+LETTERHEAD.jpg" alt="" width="100%" />
        </div>
        <div align="center">
            <br />
            <h2>Application Form for the Academic Year <span style="border-bottom: 2px solid black;">{{
                    person_details.ay }}</span></h2>
        </div>
        <div class="container custom-left-margin">
            <div style="display: flex;">
                <div style="width: 25%; float: left;">
                    <h3 style="margin: 10px;">
                        Admission Form No.:&nbsp;{{ person_details.admission_form_no }}
                    </h3>
                    <div>
                        <h3 style="margin: 10px;">Admitted Class:&nbsp;{{ person_details.standard.field_value }}</h3>
                        <h3 style="margin: 10px;">Admitted No:&nbsp;___________</h3>
                        <!-- <h3 style="margin: 10px;">Admitted Year:&nbsp;{{ person_details.ay }}</h3> -->
                    </div>
                </div>
                <div style="width: 75%; float: right;">
                    <div class="photo" v-if="person_details.parent_photo">
                        <center>
                            <v-img width="150" :src="awspath + person_details.parent_photo" aspect-ratio="1"
                                class="grey lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                            Parent`s Photo
                        </center>
                    </div>
                    <div class="photo">
                        <center>
                            <v-img width="150" :src="awspath + person_details.father_photo" aspect-ratio="1"
                                class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                            Father`s Photo
                        </center>
                    </div>
                    <div class="photo">
                        <center>
                            <v-img width="150" :src="awspath + person_details.mother_photo" aspect-ratio="1"
                                class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                            Mother`s Photo
                        </center>
                    </div>
                    <div class="photo">
                        <center>
                            <v-img width="150" :src="awspath +
                                person_details.profile_image_path +
                                person_details.profile_image_name
                                " aspect-ratio="1" class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>

                            Student`s Photo
                        </center>
                    </div>
                </div>
            </div>
        </div>
        <div class="container custom-left-margin" style="width: 105%;">
            <div class="row">
                <div class="col-12">
                    <h3 style="color: #b04759;">Student Details</h3>
                </div>
                <div class="col-4 text-center stud_details" style="" v-if="person_details.firstname != null">
                    <b> First Name</b>&nbsp;<br>
                    {{ person_details.firstname.field_value }}
                </div>
                <div class="col-4 text-center stud_details" style="" v-if="person_details.middlename != null">
                    <b> Middle Name</b>&nbsp;<br>
                    {{ person_details.middlename.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.lastname != null">
                    <b> Last Name</b>&nbsp;<br>
                    {{ person_details.lastname.field_value }}
                </div>
                <div class="col-12 stud_details" v-if="person_details.fullname != null" style="">
                    <b> Full Name:</b>&nbsp;<br>
                    {{ person_details.fullname.field_value }}
                </div>
                <div class="col-3 text-center stud_details" style="" v-if="person_details.date_of_birth != null">
                    <b> {{ person_details.date_of_birth.field_display_name }}:</b>
                    {{ person_details.date_of_birth.field_value }}
                </div>
                <div class="col-6 text-center stud_details" style=""
                    v-if="person_details.date_of_birth_in_words != null">
                    <b> {{ person_details.date_of_birth_in_words.field_display_name }}:</b>
                    {{ person_details.date_of_birth_in_words.field_value }}
                </div>
                <div class="col-3 text-center stud_details" style="" v-if="person_details.gender != null">
                    <b> {{ person_details.gender.field_display_name }}:</b>
                    {{ person_details.gender.field_value }}
                </div>
                <div class="col-6 text-center stud_details" style="" v-if="person_details.birth_place != null">
                    <b> {{ person_details.birth_place.field_display_name }}: </b>{{
                        person_details.birth_place.field_value }}
                </div>
                <div class="col-6 text-center stud_details" style="" v-if="person_details.birthcountry != null">
                    <b> {{ person_details.birthcountry.field_display_name }}: </b> {{
                        person_details.birthcountry.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.nationality != null">
                    <b> {{ person_details.nationality.field_display_name }}: </b>{{
                        person_details.nationality.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.citizenship != null">
                    <b> {{ person_details.citizenship.field_display_name }}: </b>{{
                        person_details.citizenship.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.religion != null">
                    <b> {{ person_details.religion.field_display_name }}: </b>{{ person_details.religion.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.cast != null">
                    <b> {{ person_details.cast.field_display_name }}: </b>{{ person_details.cast.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.category != null">
                    <b> {{ person_details.category.field_display_name }}: </b>{{ person_details.category.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.sub_caste != null">
                    <b> {{ person_details.sub_caste.field_display_name }}: </b>{{ person_details.sub_caste.field_value
                    }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.mothertoungue != null">
                    <b> {{ person_details.mothertoungue.field_display_name }}: </b>{{
                        person_details.mothertoungue.field_value }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.aadhar_no != null"><b>
                        {{ person_details.aadhar_no.field_display_name }}: </b>{{ person_details.aadhar_no.field_value
                    }}
                </div>
                <div class="col-4  text-center stud_details" style="" v-if="person_details.passport_no != null"><b>
                        {{ person_details.passport_no.field_display_name }}: </b>{{
                            person_details.passport_no.field_value }}
                </div>

                <div class="col-4  text-center stud_details" style="" v-if="person_details.bloodgroup != null">
                    <b> {{ person_details.bloodgroup.field_display_name }}: </b>{{ person_details.bloodgroup.field_value
                    }}
                </div>
                <div class="col-6  text-center stud_details" style="" v-if="person_details.mobile_no != null">
                    <b> Mobile No.: </b> {{ person_details.mobile_no }}
                </div>
                <div class="col-6  text-center stud_details" style="" v-if="person_details.personal_email != null">
                    <b> Primary Email: </b> {{ person_details.personal_email }}
                </div>
                <div class="col-6  text-center stud_details" v-if="person_details.is_single_girl_child != null">
                    <b> {{ person_details.is_single_girl_child.field_display_name }}: </b> {{
                        person_details.is_single_girl_child.field_value }}
                </div>
                <div class="col-6  text-center stud_details" v-if="person_details.is_EWS != null">
                    <b> {{ person_details.is_EWS.field_display_name }}: </b> {{ person_details.is_EWS.field_value }}
                </div>
                <div class="col-12  text-center stud_details" v-if="person_details.father_full_name != null">
                    <b> Father's Name: </b> {{ person_details.fullname.field_value }}
                </div>
                <div class="col-12  text-center stud_details" v-if="person_details.mother_first_name != null">
                    <b> Mother's Name: </b> {{ person_details.mother_first_name.field_value }}
                </div>
                <div class="col-12 stud_details" style="" v-if="person_details.languages_known != null">
                    <b> {{ person_details.languages_known.field_display_name }} : </b>{{
                        person_details.languages_known.field_value }}
                </div>
                <h3 style="color: #b04759;">Previous School Attended</h3>
                <div class="col-12 stud_details" style="" v-if="person_details.previous_school_name != null">
                    <b> School Name : </b> {{ person_details.previous_school_name.field_value }}
                </div>
                <div class="col-12 stud_details" style="" v-if="person_details.reason_for_leaving_last_school != null">
                    <b> Reason for leaving the School : </b> {{
                        person_details.reason_for_leaving_last_school.field_value }}
                </div>
                <div class="col-6  text-center stud_details" style=""
                    v-if="person_details.academic_program_studied != null"><b>
                        {{ person_details.academic_program_studied.field_display_name }} : </b>
                    <span v-if="person_details.academic_program_studied.field_value"> {{
                        person_details.academic_program_studied.field_value }} </span>
                    <span v-else><br><br><br><br></span>
                </div>
                <div class="col-6  text-center stud_details" style=""
                    v-if="person_details.previousschoolpassingstandard != null">
                    <b> Last Grade Attended : </b>
                    <span v-if="person_details.previousschoolpassingstandard.field_value">
                        {{ person_details.previousschoolpassingstandard.field_value }}</span>
                    <span v-else><br><br><br><br></span>
                </div>
                <div class="col-12">
                    <h3 style="color: #b04759;">Local/Current Address</h3>
                </div>
                <div class="col-3" v-if="person_details.local_address != null">
                    <b> Address</b> :
                </div>
                <div class="col-9" style="border-bottom: 2px solid black;" v-if="person_details.local_address != null">
                    <span v-if="person_details.local_address.laddress">
                        {{ person_details.local_address.laddress }}
                    </span>
                    <span v-else>
                        <br>
                        <br>
                    </span>
                </div>
                <div class="col-3" v-if="person_details.local_address != null">
                    <b> City</b>
                </div>
                <div class="col-3" style="border-bottom: 2px solid black;" v-if="person_details.local_address != null">
                    {{ person_details.local_address.lcity }}
                </div>
                <div class="col-3 text-center" v-if="person_details.local_address != null">
                    <b> State</b>
                </div>
                <div class="col-3" style="border-bottom: 2px solid black;" v-if="person_details.local_address != null">
                    {{ person_details.local_address.lstate }}
                </div>
                <div class="col-3" v-if="person_details.local_address != null">
                    <b> Country</b>
                </div>
                <div class="col-3" style="border-bottom: 2px solid black;" v-if="person_details.local_address != null">
                    {{ person_details.local_address.lcountry }}
                </div>
                <div class="col-3 text-center" v-if="person_details.local_address != null">
                    <b> Pin</b>
                </div>
                <div class="col-3" style="border-bottom: 2px solid black;" v-if="person_details.local_address != null">
                    {{ person_details.local_address.lpin }}
                </div>
                <div class="col-12">
                    <h3 style="color: #b04759;">Permanent Address</h3>
                </div>
                <div class="col-3" v-if="person_details.permanent_address != null">
                    <b> Address</b> :
                </div>
                <div class="col-9" style="border-bottom: 2px solid black;"
                    v-if="person_details.permanent_address != null">
                    <span v-if="person_details.permanent_address.paddress">
                        {{ person_details.permanent_address.paddress }}
                    </span>
                    <span v-else>
                        <br>
                        <br>
                    </span>
                </div>
                <div class="col-3" v-if="person_details.permanent_address != null">
                    <b> City</b>
                </div>
                <div class="col-3" style="border-bottom: 2px solid black;"
                    v-if="person_details.permanent_address != null">
                    {{ person_details.permanent_address.pcity }}
                </div>
                <div class="col-3 text-center" v-if="person_details.permanent_address != null">
                    <b> State</b>
                </div>
                <div class="col-3 " style="border-bottom: 2px solid black;"
                    v-if="person_details.permanent_address != null">
                    {{ person_details.permanent_address.pstate }}
                </div>
                <div class="col-3" v-if="person_details.permanent_address != null">
                    <b> Country</b>
                </div>
                <div class="col-3 " style="border-bottom: 2px solid black;"
                    v-if="person_details.permanent_address != null">
                    {{ person_details.permanent_address.pcountry }}
                </div>
                <div class="col-3 text-center" v-if="person_details.permanent_address != null">
                    <b> Pin</b>
                </div>
                <div class="col-3 " style="border-bottom: 2px solid black;"
                    v-if="person_details.permanent_address != null">
                    {{ person_details.permanent_address.ppin }}
                </div>
            </div>
        </div>
        <div style="width: 109%;" class="container custom-left-margin">
            <v-row class="pagebreak">
                <br />
                <table class="" style="width: 100%;">
                    <br />
                    <tr>
                        <h3 style="color: #b04759;">Parent / Guardian Details</h3>
                    </tr>
                    <tr>
                        <td colspan="2" class="decoration" style="width: 30%; color: #b04759;"><b>Father Details</b>
                        </td>
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_father_details != null">
                            Father
                        </td> -->
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_mother_details != null">
                            Mother
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Name</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_full_name }}
                        </td>
                        <!-- 
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_full_name }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Contact No.</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_contact_no }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_contact_no }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Email</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_email }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_email }}
                        </td> -->
                    </tr>

                    <tr>
                        <td class="decoration"><b>Aadhaar Card No.</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_aadharno }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Citizenship.</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_citizenship }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Nationality</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_nationality }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_nationality }}
                        </td> -->
                    </tr>

                    <tr>
                        <td class="decoration"><b>Qualification</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_education }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_education }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Occupation</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_occupation }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_occupation }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Designation</b></td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_designation }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_designation }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration">
                            <b>Company/Organisation</b>
                        </td>
                        <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_organization_name }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details .relative_organization_name }}
                        </td> -->
                    </tr>
                    <tr>
                        <td>
                            <b>Company/Organisation Address & Contact Details</b>
                        </td>

                        <td v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_office_address }}
                        </td>
                        <!-- <td v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_office_address }}
                        </td> -->
                    </tr>
                </table>
                <table class="" style="width: 100%;">
                    <!-- <br />
                    <tr>
                        <h3 style="color: #b04759;">Parent / Guardian Details</h3>
                    </tr> -->
                    <tr>
                        <td colspan="2" class="decoration" style="width: 30%; color: #b04759;"><b>Mother Details</b>
                        </td>
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_father_details != null">
                            Father
                        </td> -->
                        <!-- <td class="decoration" style="width: 50%;" v-if="person_details.relative_mother_details != null">
                            Mother
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Name</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_full_name }}
                        </td> -->

                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_full_name }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Contact No.</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_contact_no }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_contact_no }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Email</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_email }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_email }}
                        </td>
                    </tr>

                    <tr>
                        <td class="decoration"><b>Aadhar Card No.</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_aadharno }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Citizenship.</b></td>
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_citizenship }}
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_aadharno }}
                        </td> -->
                    </tr>
                    <tr>
                        <td class="decoration"><b>Nationality</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_nationality }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_nationality }}
                        </td>
                    </tr>

                    <tr>
                        <td class="decoration"><b>Qualification</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_education }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_education }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Occupation</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_occupation }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_occupation }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration"><b>Designation</b></td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_designation }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_designation }}
                        </td>
                    </tr>
                    <tr>
                        <td class="decoration">
                            <b>Company/Organisation</b>
                        </td>
                        <!-- <td class="decoration" v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details .relative_organization_name }}
                        </td> -->
                        <td class="decoration" v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_organization_name }}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>Company/Organisation Address & Contact Details</b>
                        </td>

                        <!-- <td v-if="person_details.relative_father_details != null">
                            {{ person_details.relative_father_details.relative_office_address }}
                        </td> -->
                        <td v-if="person_details.relative_mother_details != null">
                            {{ person_details.relative_mother_details.relative_office_address }}
                        </td>
                    </tr>
                </table>
                <table style="width: 100%;">
                    <tr>
                        <td></td>
                        <td style="color: red;">
                            <b> Guardian Details - To be contacted in case of any emergency. [Note - Other than Parent]
                            </b>
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_contact_name != null">
                        <td><b> Name</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_contact_name.field_value }}
                            <hr
                                style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_contact_number != null">
                        <td><b> Contact No.</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_contact_number.field_value }}
                            <hr
                                style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_email != null">
                        <td><b>Email</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_email.field_value }}
                            <hr
                                style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>

                    <tr v-if="person_details.emergency_contact_address != null">
                        <td><b> Address</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_contact_address.field_value }}
                            <hr
                                style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                    <tr v-if="person_details.emergency_relation != null">
                        <td><b>Relationship with the child</b>&nbsp;</td>
                        <td>
                            {{ person_details.emergency_relation.field_value }}
                            <hr
                                style="width: 100%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        </td>
                    </tr>
                </table>
                <v-simple-table style="width: 100%;" id="page"
                    v-if="person_details.relative_brother_details != null && person_details.relative_mother_details != null">
                    <tr>
                        <h3>Sibling Information</h3>
                    </tr>
                    <tr>
                        <th style="font-size: 14px;"></th>
                        <th v-if="person_details.relative_brother_details != null" style="font-size: 14px;">
                            Brother
                        </th>
                        <th v-if="person_details.relative_sister_details != null" style="font-size: 14px;">
                            Sister
                        </th>
                    </tr>
                    <hr
                        style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                    <tbody>
                        <tr>
                            <td><b>Name</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_full_name }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_full_name }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Aadhaar No</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_aadharno }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_aadharno }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Education</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_education }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_education }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Annual Income</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_income }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_income }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Email</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_email }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_email }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Organisation</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_organization_name }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_organization_name }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Designation</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_designation }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_designation }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Office Address</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_office_address }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_office_address }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Contact No</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_contact_no }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_contact_no }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Nationality</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_nationality }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_nationality }}
                            </td>
                        </tr>
                        <hr
                            style="width: 235%; border-width: 1px; color: black; background-color: black; border-style: solid;" />
                        <tr>
                            <td><b>Occupation</b></td>
                            <td v-if="person_details.relative_brother_details != null">
                                {{ person_details.relative_brother_details.relative_occupation }}
                            </td>
                            <td v-if="person_details.relative_sister_details != null">
                                {{ person_details.relative_sister_details.relative_occupation }}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-row>
        </div>
        <div class="pagebreak declaration_details">
            <v-row v-if="person_details.admission_instruction != null">
                <v-col v-if="person_details.admission_instruction
                    .admission_instructions_html_code != null
                ">
                    <div v-html="person_details.admission_instruction
                        .admission_instructions_html_code
                        "></div>
                </v-col>
                <v-col v-if="person_details.admission_instruction
                    .admission_checklist_html_code != null
                ">
                    <div v-html="person_details.admission_instruction.admission_checklist_html_code
                        "></div>
                </v-col>
            </v-row>
        </div>
        <!-- </div> -->
        <div class="container custom-left-margin">
            <div class="text-center">
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"
                    v-if="person_details != null">
                    <v-icon left>mdi-printer</v-icon>Print
                    <v-icon right></v-icon>
                </v-btn>
            </div>
            <!-- text-center -->
        </div>
    </div>
    <div id="printableContent" v-else style="background-color: white;">
        <div style="display: flex; background-color: #001d76;">
            <div style="width: 40%; float: left;">
                <br />
                <div class="row mt-2 pl-4">
                    <div class="col-2" style="padding-right: 70px;">
                        <img :src="person_details.rep_header.school_logo" width="80px" height="80px" alt="logo" />
                    </div>
                    <div class="col-3" style="margin-top: -25px;">
                        <center>
                            <div
                                style="text-transform: uppercase; font-size: 50px; font-weight: bolder; color: white; font-family: 'Times New Roman', Times, serif;">
                                Zeal</div>
                            <br />
                            <div
                                style="margin-top: -45px; text-transform: uppercase; font-size: 23px; font-weight: bolder; color: white; font-family: 'Times New Roman', Times, serif;">
                                Institutes</div>
                        </center>
                    </div>
                    <div id="logo_div" class="col-2" style="padding-left: 25px;">
                        <img :src="person_details.rep_header.trust_logo" width="80px" height="80px" alt="logo" />
                    </div>
                </div>
                <div class="row">
                    <div class="col-6" id="title_id" style="margin-top: -57px; margin-left: 40px;">
                        <center>
                            <span
                                style="font-size: small; font-weight: bolder; color: white; font-family: 'Times New Roman', Times, serif;">
                                www.zealeducation.com</span>
                        </center>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6" id="title_id" style="margin-top: -40px; margin-left: 40px;">
                        <center>
                            <span
                                style="font-size: small; font-weight: bolder; color: white; font-family: 'Times New Roman', Times, serif;">Narhe
                                | Pune | India</span>
                        </center>
                    </div>
                </div>
                <div class="row pl-4" style="margin-top: -15px;">
                    <center>
                        <span
                            style="text-transform: uppercase; font-size: x-small; white-space: nowrap; font-weight: bolder; color: white;">schools
                            | jr.college | iti | Polytechnic | Enineering | MBA | Mca | ph D</span>
                    </center>
                </div>
                <br />
            </div>

            <div style="width: 60%; float: right;">
                <br />
                <h3 style="color: white;">
                    {{ person_details.rep_header.trust_name }}
                </h3>
                <h1 style="text-transform: uppercase; text-decoration: underline; color: white; margin-top: -10px;">
                    {{ person_details.rep_header.school_name }}
                </h1>
                <h4 style="text-transform: uppercase; color: white;" class="mdi mdi-map-marker">
                    {{ person_details.rep_header.address }}
                </h4>
                <div style="font-weight: bold; color: white;">
                    <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                    <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                        }}</span><br />
                    <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-7 text-right">
                <span
                    style="text-transform: uppercase; color: #001d76; font-size: xx-large; font-weight: bold; font-family: Arial;">Admission
                    Form </span>
            </div>
            <div class="col-5 text-center mt-6">
                <span style="padding: 15px 150px 15px 10px; border: solid 1px;"> <span
                        style="text-transform: uppercase; font-weight: bolder; font-size: large;">Form No : {{
                            person_details.admission_form_no }}</span>&nbsp; </span>
            </div>
        </div>
        <div class="row">
            <div class="col-12 text-center" style="margin-top: -30px; padding-right: 100px;">
                <span style="text-transform: uppercase; color: #001d76; font-size: x-large; font-weight: bold;">AY {{
                    person_details.ay }}</span>
            </div>
        </div>

        <div style="display: flex;">
            <div style="width: 25%; float: left;">
                <div
                    style="float: left; margin-top: 40px; margin-left: 10px; width: 80%; padding: 5px; border: solid 1px;">
                    <span style="font-weight: bolder; font-size: large;">
                        GEN REG NO :
                    </span>
                </div>
            </div>
            <div style="width: 75%; float: right;">
                <div class="photo" v-if="person_details.parent_photo">
                    <center>
                        <v-img width="150" :src="awspath + person_details.parent_photo" aspect-ratio="1"
                            class="grey lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                        Parent`s Photo
                    </center>
                </div>
                <div class="photo">
                    <center>
                        <v-img width="150" :src="awspath + person_details.father_photo" aspect-ratio="1"
                            class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                        Father`s Photo
                    </center>
                </div>
                <div class="photo">
                    <center>
                        <v-img width="150" :src="awspath + person_details.mother_photo" aspect-ratio="1"
                            class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>
                        Mother`s Photo
                    </center>
                </div>
                <div class="photo">
                    <center>
                        <v-img width="150" :src="awspath +
                            person_details.profile_image_path +
                            person_details.profile_image_name
                            " aspect-ratio="1" class="lighten-2" style="border: 3px solid #1e4e78; border-radius: 10px;"></v-img>

                        Student`s Photo
                    </center>
                </div>
            </div>
        </div>
        <div class="container custom-left-margin" style="width: 105%;">
            <div class="row">
                <div class="col-12">
                    <h3 style="color: #001d76; text-transform: uppercase;">A) Student Details :</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h3>Name (Fill in Block Letters)</h3>
                </div>
            </div>
            <div class="detail-field row pl-2">
                <div style="border: solid 1px;" v-if="person_details.lastname != null">{{
                    person_details.lastname.field_value }}</div>
                <div style="border: solid 1px;" v-if="person_details.firstname != null">{{
                    person_details.firstname.field_value }}</div>
                <div style="border: solid 1px;" v-if="person_details.middlename != null">{{
                    person_details.middlename.field_value }}</div>
                <div style="border: solid 1px;" v-if="person_details.mother_first_name != null">{{
                    person_details.mother_first_name.field_value }}</div>
            </div>
            <div class="detail-field row mt-4">
                <div>(SurName)</div>
                <div>(Name)</div>
                <div>(Father's Name)</div>
                <div>(Mother's Name)</div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span style="display: inline-block; width: 50%;">
                        <b>Admission sought for </b><span class="wrapper" v-if="person_details.standard != null"
                            style="width: 70%;">{{ person_details.standard.field_value }}</span>
                    </span>
                    <span style="display: inline-block; width: 30%;">
                        <b>Standard </b><span class="wrapper" v-if="person_details.shift != null"
                            style=" width: 78%;">{{ person_details.shift.field_value }}</span>
                    </span>
                    <span style="display: inline-block; width: 20%;"><b>Shift(Morning/Afternoon) </b><span
                            style="border-bottom: 1px solid black;"></span></span>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.date_of_birth != null" style="display: inline-block; width: 50%;">
                        <b>{{ person_details.date_of_birth.field_display_name }} </b> <span class="wrapper"
                            style=" width: 81%;"> {{ person_details.date_of_birth.field_value }}</span>
                    </span>
                    <span v-if="person_details.birth_place != null" style="display: inline-block; width: 50%;">
                        <b>{{ person_details.birth_place.field_display_name }} </b><span class="wrapper"
                            style=" width: 78%;">{{ person_details.birth_place.field_value }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.gender != null" style="flex: 1;">
                        <b> {{ person_details.gender.field_display_name }}: </b><span class="wrapper"
                            style=" width: 75%;">{{ person_details.gender.field_value }}</span>
                    </span>
                    <span v-if="person_details.bloodgroup != null" style="flex: 1;">
                        <b> {{ person_details.bloodgroup.field_display_name }}: </b><span class="wrapper"
                            style=" width: 65%;">{{ person_details.bloodgroup.field_value }}</span>
                    </span>
                    <span v-if="person_details.mothertoungue != null" style="flex: 1;">
                        <b>{{ person_details.mothertoungue.field_display_name }}: </b><span class="wrapper"
                            style=" width: 52%;">{{ person_details.mothertoungue.field_value }}</span>
                    </span>
                    <span v-if="person_details.nationality != null" style="flex: 1;">
                        <b>{{ person_details.nationality.field_display_name }}: </b><span class="wrapper"
                            style=" width: 54%;">{{ person_details.nationality.field_value }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.aadhar_no != null" style="display: inline-block; width: 100%;">
                        <b> {{ person_details.aadhar_no.field_display_name }} : </b><span class="wrapper"
                            style=" width: 39%;">{{ person_details.aadhar_no.field_value }}</span> (Attach Copy)
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.previous_school_name != null"
                        style="display: inline-block; width: 100%;">
                        <b> Last School Attended : </b><span class="wrapper" style=" width: 83%;">{{
                            person_details.previous_school_name.field_value }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.mediumofinstruction != null" style="display: inline-block; width: 100%;">
                        <b> Medium Of instructions(Marathi/English/Other) </b><span class="wrapper"
                            style=" width: 68%;">{{ person_details.mediumofinstruction.field_value }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.previousschoolpassingstandard != null"
                        style="display: inline-block; width: 50%;">
                        <b> Last Standard Attended </b><span class="wrapper" style=" width: 69%;">{{
                            person_details.previousschoolpassingstandard.field_value }}</span>
                    </span>
                    <span v-if="person_details.previousschoolschoolboard != null"
                        style="display: inline-block; width: 50%;">
                        <b> Last School Board (State/CBSC/ICSE/Other) </b><span class="wrapper" style=" width: 40%;">{{
                            person_details.previousschoolschoolboard.field_value }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.physicallyhandicapped_details != null"
                        style="display: inline-block; width: 100%;">
                        <b> Is child Physically Challenged? Yes/No </b><span class="wrapper" style=" width: 10%;">{{
                            person_details.physicallyhandicapped_details.field_value }}</span> (if Yes Attach Medical
                        Certificate)
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.medical_problem != null" style="display: inline-block; width: 100%;">
                        <b> Is child suffering from other medical / allergic problem ? Yes / No </b><span
                            class="wrapper" style=" width: 10%;">{{ person_details.medical_problem.field_value }}</span>
                        (if Yes
                        Attach Medical Certificate)
                    </span>
                </div>
            </div>
            <div class="row" v-if="orgid == 1">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.sibling1 != null" style="display: inline-block; width: 45%;">
                        <b> Sibling Studying in DEMS - Name </b><span class="wrapper" style=" width: 48%;">{{
                            person_details.sibling1.sibling_name }}</span>
                    </span>
                    <span v-if="person_details.sibling1 != null" style="display: inline-block; width: 30%;">
                        <b> Class </b><span class="wrapper" style=" width: 86%;">{{ person_details.sibling1.standard
                            }}</span>
                    </span>
                    <span v-if="person_details.sibling1 != null" style="display: inline-block; width: 30%;">
                        <b> Shift(Morning/Afternoon) </b><span class="wrapper"
                            style=" width: 34%;">{{ person_details.sibling1.shift }}</span>
                    </span>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.sibling1 != null" style="display: inline-block; width: 45%;">
                        <b> Sibling Studying in SCS - Name </b><span class="wrapper" style=" width: 51%;">{{
                            person_details.sibling1.sibling_name }}</span>
                    </span>
                    <span v-if="person_details.sibling1 != null" style="display: inline-block; width: 30%;">
                        <b> Class </b><span class="wrapper" style=" width: 86%;">{{ person_details.sibling1.standard
                            }}</span>
                    </span>
                    <span v-if="person_details.sibling1 != null" style="display: inline-block; width: 30%;">
                        <b> Shift(Morning/Afternoon) </b><span class="wrapper"
                            style=" width: 34%;">{{ person_details.sibling1.shift }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h3 style="color: #001d76; text-transform: uppercase;">B) Parent Details :</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.relative_father_details != null"
                        style="display: inline-block; width: 100%;">
                        <b>Father's Full Name : </b><span class="wrapper" style=" width: 85%;"> {{
                            person_details.relative_father_details.relative_full_name }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.relative_father_details != null"
                        style="display: inline-block; width: 100%;">
                        <b>Aadhaar Card No : </b><span class="wrapper" style=" width: 10%;"> {{
                            person_details.relative_father_details.relative_aadharno }}</span>(Attach Copy)
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.relative_father_details != null" style="flex: 1;">
                        <b>Mobile No : </b><span class="wrapper" style=" width: 83%;"> {{
                            person_details.relative_father_details.relative_contact_no }}</span>
                    </span>
                    <span v-if="person_details.relative_father_details != null" style="flex: 1;">
                        <b>Email Id : </b><span class="wrapper" style=" width: 82%;"> {{
                            person_details.relative_father_details.relative_email }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.relative_father_details != null" style="flex: 1;">
                        <b>Educational Education : </b><span class="wrapper" style=" width: 69%;"> {{
                            person_details.relative_father_details.relative_education }}</span>
                    </span>
                    <span v-if="person_details.relative_father_details != null" style="flex: 1;">
                        <b>Occupation : </b><span class="wrapper" style=" width: 78%;"> {{
                            person_details.relative_father_details.relative_occupation }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.relative_father_details != null"
                        style="display: inline-block; width: 100%;">
                        <b>Annual Income (Family) : </b><span class="wrapper" style=" width: 82%;">{{
                            person_details.relative_father_details.relative_income }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.religion != null" style="flex: 1;">
                        <b>{{ person_details.religion.field_display_name }} : </b><span class="wrapper"
                            style=" width: 80%;"> {{ person_details.religion.field_value }}</span>
                    </span>
                    <span v-if="person_details.cast != null" style="flex: 1;">
                        <b>{{ person_details.cast.field_display_name }} : </b><span class="wrapper"
                            style=" width: 85%;"> {{ person_details.cast.field_value }}</span>
                    </span>
                    <span v-if="person_details.category != null" style="flex: 1;"><b>Caste Category : </b><span
                            class="wrapper" style=" width: 61%;"> {{ person_details.category.field_value
                            }}</span></span>
                </div>
            </div>
        </div>
        <div style="width: 105%;" class="pagebreak container custom-left-margin">
            <br />
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.relative_mother_details != null"
                        style="display: inline-block; width: 100%;">
                        <b>Mother's Full Name : </b><span class="wrapper" style=" width: 85%;"> {{
                            person_details.relative_mother_details.relative_full_name }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.relative_mother_details != null"
                        style="display: inline-block; width: 100%;">
                        <b>Aadhaar Card No : </b><span class="wrapper" style=" width: 10%;"> {{
                            person_details.relative_mother_details.relative_aadharno }}</span>(Attach Copy)
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.relative_mother_details != null" style="flex: 1;">
                        <b>Mobile No : </b><span class="wrapper" style=" width: 83%;"> {{
                            person_details.relative_mother_details.relative_contact_no }}</span>
                    </span>
                    <span v-if="person_details.relative_mother_details != null" style="flex: 1;">
                        <b>Email Id : </b><span class="wrapper" style=" width: 82%;"> {{
                            person_details.relative_mother_details.relative_email }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.relative_mother_details != null" style="flex: 1;">
                        <b>Educational Education : </b><span class="wrapper" style=" width: 69%;"> {{
                            person_details.relative_mother_details.relative_education }}</span>
                    </span>
                    <span v-if="person_details.relative_mother_details != null" style="flex: 1;">
                        <b>Occupation : </b><span class="wrapper" style=" width: 78%;"> {{
                            person_details.relative_mother_details.relative_occupation }}</span>
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h3 v-if="person_details.local_address != null" style="color: #001d76; text-transform: uppercase;">
                        C. Address For Correspondence : (Attach Proof)</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.local_address.laddress != null"><span class="wrapper"
                            style=" width: 100%;"> {{ person_details.local_address.laddress }}</span></span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.local_address != null" style="flex: 1;">
                        <b>City / Village : </b><span class="wrapper" style=" width: 62%;"> {{
                            person_details.local_address.lcity }}</span>
                    </span>
                    <span v-if="person_details.local_address != null" style="flex: 1;"><b>Tehsil : </b><span
                            class="wrapper" style=" width: 78%;">{{ person_details.local_address.ltaluka
                            }}</span></span>
                    <span v-if="person_details.local_address != null" style="flex: 1;"><b>District : </b><span
                            class="wrapper" style=" width: 76%;">{{ person_details.local_address.ldistrict
                            }}</span></span>
                    <span v-if="person_details.local_address != null" style="flex: 1;"><b>PIN : </b><span
                            class="wrapper" style=" width: 74%;"> {{ person_details.local_address.lpin }}</span></span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h3 style="color: #001d76; text-transform: uppercase;">D. Permanent Address : (Attach Proof)</h3>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <span v-if="person_details.permanent_address != null"><span class="wrapper" style=" width: 100%;"> {{
                        person_details.permanent_address.paddress }}</span></span>
                    <span v-else>
                        <br />
                        <br />
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12" style="display: flex;">
                    <span v-if="person_details.permanent_address != null" style="flex: 1;">
                        <b>City / Village :</b><span class="wrapper" style=" width: 62%;"> {{
                            person_details.permanent_address.pcity }}</span>
                    </span>
                    <span v-else>
                        <br />
                        <br />
                    </span>
                    <span v-if="person_details.permanent_address != null" style="flex: 1;"><b>Tehsil : </b><span
                            class="wrapper" style=" width: 78%;">{{ person_details.permanent_address.ptaluka }}
                        </span></span>
                    <span v-else>
                        <br />
                        <br />
                    </span>
                    <span v-if="person_details.permanent_address != null" style="flex: 1;">
                        <b>District : </b><span class="wrapper" style=" width: 76%;">{{
                            person_details.permanent_address.pdistrict }}</span>
                    </span>
                    <span v-else>
                        <br />
                        <br />
                    </span>
                    <span v-if="person_details.permanent_address != null" style="flex: 1;"><b>PIN : </b><span
                            class="wrapper" style=" width: 74%;"> {{ person_details.permanent_address.ppin
                            }}</span></span>
                    <span v-else>
                        <br />
                        <br />
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <h3 style="color: #001d76; text-transform: uppercase;">e. Declaration</h3>
                </div>
            </div>
            <div class="row">
                <v-row v-if="person_details.admission_instruction != null">
                    <v-col v-if="person_details.admission_instruction.admission_instructions_html_code != null">
                        <div v-html="person_details.admission_instruction.admission_instructions_html_code"></div>
                    </v-col>

                </v-row>
            </div>
            <div class="row">
                <v-row v-if="person_details.admission_instruction != null">
                    <v-col v-if="person_details.admission_instruction.admission_checklist_html_code != null">
                        <div v-html="person_details.admission_instruction.admission_checklist_html_code"></div>
                    </v-col>

                </v-row>
            </div>
        </div>
    </div>







</template>

<script>
export default {
    props: ["person_details"],
    created() {
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.orgid = localStorage.getItem("EPS-org-id");
        console.log("zeal");
    },
    methods: {
        print() {
            setTimeout(function () {
                window.print();
            }, 100);
        },
    },
};
</script>
<!-- <style scoped>

.wrapper {
    border-bottom: 1px solid black;
    display: inline-block;
}

.detail-field > div {
    width: 23.5%;
    height: 30px;
    display: inline-block;
    text-align: center;
    font-weight: bolder;
}

.table {
    width: 100%;
    border-collapse: collapse;
}

.table td {
    border: 1px solid black;
    padding: 8px;
}

td {
    padding-bottom: 2px;
}

td, th, tr {
    font-weight: normal;
    font-style: normal;
    font-size: 16px;
}

.text-center {
    text-align: center;
}

.decoration {
    border-bottom: 2px solid black;
    padding-top: 5px;
}


#one_view_form {
    width: 1000px;
    height: 1400px;
    margin: auto;
    padding: 13px 5px;
}

.printdiv {
    box-sizing: border-box;
    border: 2px solid black;
    padding: 10px;
    min-height: calc(297mm - 40mm);
}



.personal_details {
    border: 2px solid black;
    border-radius: 20px;
    padding-bottom: 5px;
}

.medical_details {
    margin-left: 3px;
}

.parent_details td,
.parent_details tr,
.parent_details th {
    font-size: 16px;
}

.declaration_details {
    font-size: larger;
}

.sib_table {
    border-bottom: 1px solid black;
}


.photo {
    float: right;
    margin: 15px;
}

#application_form {
    text-align: center;
    color: red;
    font-family: Arial, sans-serif;
    font-size: 130%;
    border: 2px solid blue;
    width: 230px;
}

.custom-left-margin {
    margin-left: 20px;
}


.jumbotron {
    font-family: "Nunito Sans", sans-serif;
    background: url("https://universal-wws-schoolerp.s3.ap-south-1.amazonaws.com/logo/uwws_background_admission_form.png")
        no-repeat center center;
    background-size: 100% 100%;
    height: 1590px;
    padding-top: 5%;
    padding-bottom: 1%;
}


.page-border {
    display: none;
}

@media screen {
    .page-border {
        display: none;
    }
}


@media print {

    /* Page setup */
    @page {
        size: A4;
        margin: 10mm;
    }

    html, body {
        margin: 0;
        padding: 0;
    }

    body > *:not(#printableContent) {
        display: none !important;
    }

    #printableContent {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin-top: -70px;
    }

    #printableContent *,
    #one_view_form * {
        visibility: visible;
    }

    .no-display,
    .v-input__control,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card,
    header,
    footer,
    nav,
    date {
        display: none !important;
    }


    td {
        padding-bottom: 10px;
    }

    .printdiv,
    #printableContent {
        border: none !important;
        padding: 10mm;
    }


    .pagebreak {
        page-break-before: always;
        padding-top: 5px;
    }


    .page-border {
        display: block;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px solid black;
        box-sizing: border-box;
        pointer-events: none;
        z-index: 9999;
    }
}


th:first-of-type {
    border-top-left-radius: 20px;
}

th:last-of-type {
    border-top-right-radius: 20px;
}

tr:last-of-type td:first-of-type {
    border-bottom-left-radius: 20px;
}

tr:last-of-type td:last-of-type {
    border-bottom-right-radius: 20px;
}

</style> -->

<style scoped>
/* Web view styles */
.wrapper {
    border-bottom: 1px solid black;
    display: inline-block;
}

.detail-field > div {
    width: 23.5%;
    height: 30px;
    display: inline-block;
    text-align: center;
    font-weight: bolder;
}

.table td {
    border: 1px solid black;
    padding: 8px;
}

/* Base font increased by 10% */
td, th, tr {
    font-weight: normal;
    font-size: 17.5px; 
}

.text-center { text-align: center; }

.decoration {
    border-bottom: 2px solid black;
    padding-top: 5px;
}

/* Base container */
.printdiv, #printableContent {
    box-sizing: border-box;
    width: 100%;
    margin: 0 auto;
    background-color: white;
}

.photo {
    float: right;
    margin: 10px;
}

/* --- PRINT LAYOUT --- */
@media print {
    @page {
        size: A4;
        margin: 5mm; 
    }

    html, body {
        margin: 0 !important;
        padding: 0 !important;
    }

    body > *:not(.printdiv):not(#printableContent) {
        display: none !important;
    }

    /* Main container with requested Right Padding */
    .printdiv, #printableContent {
        position: static !important;
        width: 100% !important;
        /* Padding: Top, Right (increased), Bottom, Left */
        padding: 12mm 20mm 12mm 15mm !important; 
        box-sizing: border-box !important;
    }

    /* Keep font size consistent at 17.5px (10% increase) for printing */
    td, th, tr, div, p, span {
        font-size: 17.0px !important;
    }

    /* Section headers (h3) also increased */
    h3 {
        font-size: 20px !important;
    }

    /* Border remains close to page edge (4mm) */
    .page-border {
        display: block !important;
        position: fixed;
        top: 4mm;   
        left: 4mm;
        right: 4mm;
        bottom: 4mm;
        border: 2px solid black;
        z-index: 9999;
        pointer-events: none;
        box-sizing: border-box;
    }

    table, .row {
        width: 100% !important;
    }

    img[alt=""] {
        width: 100% !important;
    }

    .pagebreak {
        page-break-before: always !important;
        padding-top: 15mm !important; 
        display: block;
        clear: both;
    }

    .row, h3 {
        page-break-inside: avoid;
    }

    .no-display, .v-btn, .v-icon, button {
        display: none !important;
    }
}

@media screen {
    .page-border {
        display: none;
    }
}
</style>